export const timeFormat = (dateStr) => {
  const date = new Date(dateStr);

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return hours + ":" + minutes;
};
